import type { UseFormReturn } from 'react-hook-form';
import { useContext } from 'react';
import {
  generateThemeFromSourceColor,
  isValidHexColor,
  Labeled,
  ThemeSetterContext,
} from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { ILookAndFeelSettingsFormValues } from './LookAndFeelSettingsForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { CustomColorInputField } from '~/components/organisms/fields/CustomColorInputField';

export type ILookAndFeelSettingsFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<ILookAndFeelSettingsFormValues>;
};

export const LookAndFeelSettingsFormMainSection: React.FC<
  ILookAndFeelSettingsFormMainSectionProps
> = ({ sx, form }) => {
  const { t } = useTranslation();
  const themeSetterContext = useContext(ThemeSetterContext);

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t('LookAndFeelSettingsFormMainSection.field.primaryColor.label')}
        supportingText={t(
          'LookAndFeelSettingsFormMainSection.field.primaryColor.supportingText',
        )}
      >
        <FormField
          name="appThemeColorPrimary"
          control={form.control}
          as={CustomColorInputField}
          forwardError
          rules={{
            onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
              const color = event.target.value;
              if (isValidHexColor(color)) {
                themeSetterContext?.setTheme(
                  generateThemeFromSourceColor(color),
                );
              }
            },
          }}
          palette="regular"
          quantizeColorCount={8}
          clearable
        />
      </Labeled>
    </FormSection>
  );
};
